const componentStyles = (theme) => ({
  taskListItem: {
    border: "1px solid #e9ecef",
    borderWidth: "0 0 1px",
    "&:last-child": {
      borderBottomWidth: 0,
    },
  },
  taskTitle: {
    marginBottom: 7,
    fontWeight: "bold",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column-reverse",
    cursor: "pointer",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
    "&:hover": {
      color: "#ccc",
    },
  },
  taskDescWrap: {
    margin: "20px 10px 20px 100px",
    backgroundColor: theme.palette.gray[100],
    padding: 10,
    borderRadius: 3,
  },
  taskParams: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
    backgroundColor: "#fff",
    padding: 10,
    border: "1px solid #eee",
  },
  taskParam: {
    display: "flex",
    fontSize: "90%",
    [theme.breakpoints.up("md")]: {
      marginRight: 20,
    },
  },
  taskParamValue: {
    fontWeight: "bold",
  },
  taskDesc: {
    marginBottom: 10,
    padding: 5,
  },
  taskActions: {
    marginRight: 20,
    justifyContent: "flex-end",
  },
});

export default componentStyles;
